import React from 'react'
import { Table } from 'react-bootstrap'
import useReport from './use-report'
import Center from '../../common/center'
import CSVDownloader from './csv-downloader'
import Button from '../../common/spinner-button'

const ScrollSection = ({ children }) => (
    <div
        style={{
            maxHeight: '400px',
            overflowY: 'auto',
            border: '1px solid rgb(62, 99, 250)',
            borderRadius: '5px'
        }}
    >
        {children}
    </div>
)

const Report = ({
    reportId,
    queryFields = {}
}) => {
    const {
        isLoading,
        generateReport,
        records,
        columns,
        date
    } = useReport({
        id: reportId,
        queryFields,
    })

    const renderHeaderColumn = (column, index) => (
        <th key={index}>{column}</th>
    )

    const renderRowColumn = ({ key, value }) => (
        <td key={key}>{value}</td>
    )

    const renderRow = (row, index) => (
        <tr key={index}>
            {columns.map(c => renderRowColumn({ key: `${index}-${c}`, value: row[c] }))}
        </tr>
    )

    const renderReport = () => {
        if (!date || isLoading) {
            return null
        }
        if (!records || !records.length) {
            return (
                <Center>Nothing generated</Center>
            )
        }

        return (
            <ScrollSection>
                <Table striped bordered hover size="sm" responsive>
                    <caption>records: {records.length}</caption>
                    <thead>
                        <tr>
                            {columns.map(renderHeaderColumn)}
                        </tr>
                    </thead>
                    <tbody>
                        {records.map(renderRow)}
                    </tbody>
                </Table>
            </ScrollSection>
        )
    }

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', paddingTop: '10px', paddingBottom: '10px' }}>
                <Button onClick={() => generateReport()} disabled={isLoading} busy={isLoading}>Generate Report</Button>
            </div>
            {renderReport()}
            <Center>
                <CSVDownloader records={records} columns={columns} name={reportId} />
            </Center>
        </div>
    )
}

export default Report